<template>
  <div class="index">
    <div class="pre">
      <div>
        <div class="pre_left" v-if="device !== 'mobile'">
          <span class="prel_sp1">药方分类</span>
          <el-tree :data="data" @node-click="handleNodeClick">
             <template slot-scope="{ data }">
                <span :class=" data.id==selectedNodeId  ? 'selected' : '' ">{{ data.label }}</span>
              </template>
          </el-tree>
        </div>
      </div>

      <div class="pre_right">
        <div class="prer_top">
          按&nbsp;拼&nbsp;音&nbsp;搜&nbsp;索：
          <span
            v-for="(item, index) in list"
            :key="index"
            :class="pretselect == index ? 'prer_top_select' : ''"
            @click="select(index)"
            >{{ item }}</span
          >
        </div>
        <div class="prer_bot">
          <div class="prerbot_d1">
            <ul v-for="(item, index) in prescriptionList" :key="index">
              <li>
                <span @click="toDetail(item.id,item.chinese_name)">{{ item.chinese_name }}</span>
              </li>
            </ul>
          </div>
          <div class="prerbot_d2">
            <el-pagination
              class="prerbot_d2_elp"
              background
              @current-change="handleCurrentChange"
              :page-size="30"
              :layout="
                device === 'mobile'
                  ? 'prev, pager'
                  : 'total, prev, pager, next, jumper'
              "
              :total="allCount"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="indexd3">
      <img src="../Home/img/图层49.png" />
    </div>
    <div class="index_d2">
      <div class="indexd2_top">
        <p>产品推荐</p>
      </div>
      <div class="indexd2_down">
        <div class="prolist" v-for="(item, index) in proList" :key="index"  @click="toNCPDetail(item.id)" >
          <img class="pro_img" :src="addImgUrl(item.Pic)">
          <div class="pro_text">{{ item.Intro}}</div>
          <div class="pro_pic">￥<span>{{ item.Price }}</span></div>
          <a>
            <img @click.stop="AddCart(item.id)" class="pro_gwcimg" src="../Home/img/gouWuChe.png" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addImgUrl } from "@/utils";
import { toLogin } from "@/utils";
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      list: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "X",
        "Y",
        "Z",
      ],
      pretselect: -1,
      allCount: "",
      page: 0,
      imgUrl: "",
      rxlist: [],
      prescriptionList: [],
      data: [],
      typeId: "",
      proList:[],
      selectedNodeId: null,
      ProductSizeId:'',
			num:1,
			id:'',
    };
  },
  computed: {
    ...mapGetters([ "userId","seachKey","device"]),
  },
  watch: {
    seachKey(newval, olval) {
			this.page = 0
			this.getJDList()
        },
  },
  created: function () {
    this.imgUrl = this.$store.state.imgUrl;
  },
  mounted: function () {
    this.GetFormulaTypeList();
    this.getJDList();
    this.getRXProductList();
    this.GetNcpProductList();
  },
  methods: {
    ...mapMutations("goods", ["SET_SEACH_KEY"]),
    addImgUrl,
    select(index) {
      if (this.pretselect == index) {
        this.pretselect = -1;
      } else {
        this.pretselect = index;
      }
      this.getJDList();
    },
    GetFormulaTypeList() {
      var that = this;
      that.$post("GetFormulaTypeList", {}).then(function (res) {
        var list = res.data.ResultData;
        var dataList = [];
        for (var i in list) {
          dataList.push({
            label: list[i].name,
            id: list[i].id,
          });
        }
        that.data = dataList;
      });
    },
    getJDList() {
      var that = this;
      that
        .$post("GetJDList", {
          page: that.page,
          TypeId: that.typeId,
          KeyWords: that.seachKey,
          firstCode: that.pretselect != -1 ? that.list[that.pretselect] : "",
        })
        .then(function (res) {
          that.prescriptionList = res.data.ResultData;
          that.allCount = res.data.RowCount;
        });
    },
    handleCurrentChange(e) {
      this.page = e - 1;
      window.scrollTo(0, 0);
      this.getJDList();
    },
    async getRXProductList() {
      let res = await this.$post("GetNcpProductList", {});
      this.rxlist = res.data.ResultData;
      for (var i in this.rxlist) {
        this.rxlist[i].Pic = this.rxlist[i].Pic.split(",")[0];
      }
    },
    async GetNcpProductList() {
      let res = await this.$post("GetNcpProductList", {
        pageSize: 4,
      });
      console.log(res,'proList');
      this.proList = res.data.ResultData;
      this.proList.forEach((pro) => {
        pro.Intro = this.truncate(pro.Intro,15)
        console.log(pro.Intro);
      });
    },
    async AddCart(id) {
		  this.id=id
        if (this.userId == "") {
          this.$router.push("/login");
          this.$message.error("请先登录后查看");
          return;
        }
		  let res = await this.$post("productDeatil", {id: this.id});
		  console.log(res,'productDeatil');
        this.ProductSizeId=res.data.ResultData.SizeList[0].id;
        if(this.ProductSizeId==''){
          this.$message.error("商品维护中，暂不可加入购物车");
        }else{
          let res = await this.$post("AddCart", {
            ProductId: this.id,
            Count: this.num,
            ProductSizeId:this.ProductSizeId
          });
          console.log(res,'addcart');
          this.$store.commit('updatecarSize', res.data.RowCount)
          if (res.data.Success == "true") {
            this.$message({
              message: res.data.Msg,
              type: "success",
            });
          } else {
            this.$message.error(res.data.Msg);
          }
        }
    },	
    handleNodeClick(e) {
      this.selectedNodeId = e.id;
      console.log(this.selectedNodeId,'select');
      this.typeId = e.id;
      this.page = 0;
      this.pretselect = -1;
      this.getJDList();
    },
    toDetail(id,jdname) {
      if (this.userId == "") {
        toLogin(this);
        this.$message.error("请先登录后查看");
      } else {
        this.$router.push({
          path: "/prescriptionDetail",
          query: {
            id: id,
            // jdname:jdname,
          },
        });
      }
    },
    toNCPDetail(id) {
				this.$router.push({
					path: '/ncpgoodsdetail',
					query: {
						id: id
					}
				});
		},
    truncate(value, length) {
     if (!value || value.length <= length) {
       return value;
     }
     return value.slice(0, length) + "...";
    },
  },
};
</script>


<style scoped >
.pre_right{
  margin-top: 10px;
}
.index {
  width: 100%;
  background-image: url("../Home/img/组17.png");
  background-size: cover;
  /* 调整背景图片的尺寸，以填充整个容器 */
  background-position: center;
}
.indexd3 {
  width: 100%;
  margin-top: 50px;
}
.indexd3 img {
  width: 100%;
}
.index_d2 {
  width: 100%;
}
.indexd2_top{
  margin: 0 auto;
  width: 465px;
  height: 100px;
  margin-top: 50px;
  background-image: url("../Home/img/图层44.png");
  background-size: 100% 100%;
  text-align: center;
  line-height: 100px;
  letter-spacing: 20px;
  font-size: 36px;
  font-family: "SimSun", "STSong", serif;
  font-weight: bold;
  color: white;
}
.indexd2_top p{
  margin-left: 40px;
}
.indexd2_down{
  width: 60%;
  margin: 0 auto;
  margin-top: 50px;
  display: flex;
}
.prolist{
  border: 2px solid #ccc;
  margin: 15px;
  background-color: white;
  padding: 10px 20px;
}
.pro_img{
  width: 200px;
}
.pro_text{
  font-size:0.8em;
  
}
.pro_pic{
  color: red;
  margin-top: 15px;
  float: left;
}
.pro_pic span{
  font-size: 1.5em;
}
.pro_gwcimg{
  height: 25px;
  width: 25px;
  margin-top: 20px;
  float: right;
}
::v-deep .el-tree-node__content {
  font-size: 14px;
}
.selected {
  color: red;
}
</style>
<style lang="scss" scoped src="./mobile.scss" ></style>